export default String.raw`
{% include 'partials/common/date-format.html' -%}
{% assign formalContent = null %}

{% if page.PageId == config.DefinedPages.Privacy.Id  %}
    {% assign formalContent = config.TOS.FormalContents.Privacy %}
{% endif %}

{% if page.PageId == config.DefinedPages.Terms.Id %}
    {% assign formalContent = config.TOS.FormalContents.Terms %}
{% endif %}

{% if page.PageId == config.DefinedPages.Shipping.Id  %}
    {% assign formalContent = config.TOS.FormalContents.Shipping %}
{% endif %}

{% if page.PageId == config.DefinedPages.Payment.Id  %}
    {% assign formalContent = config.TOS.FormalContents.Payment %}
{% endif %}

{% if page.PageId == config.DefinedPages.About.Id  %}
    {% assign formalContent = config.TOS.FormalContents.About %}
{% endif %} 

{% if page.PageId == config.DefinedPages.WithdrawalRight.Id %}
    {% assign formalContent = config.TOS.FormalContents.WithdrawalRight %}
{% endif %}

{% if page.PageId == config.DefinedPages.Complaints.Id %}
    {% assign formalContent = config.TOS.FormalContents.Complaints %}
{% endif %}

{% if page.PageId == config.DefinedPages.Loyalty.Id -%}
	{% assign formalContent = config.TOS.FormalContents.Loyalty -%}
{% endif -%}

{% if page.PageId == config.DefinedPages.31.Id -%}
    {% assign formalContent = config.TOS.FormalContents.SizeGuide -%}
{% endif -%}

{% assign fileCount = formalContent.Files | Size %}

<article class="formal-content">
    {% if formalContent.Id > 0 %}
        <section class="content">
            <section class="content__header">
                <h2>{{ formalContent.Name }}</h2>
                <span class="date">
                    <span class="date__text">{{ translations.PublishedDate }}:</span>
                    <time datetime="{{ FormalContent.PublishedDate | Date: 'yyyy-MM-dd HH:mm:ss' }}">{{ formalContent.PublishedDate | Date:dateFormat }}</time>
                </span>
            </section>
        {{ formalContent.ContentHtml }}
        </section>
    {% endif %}
    {% if formalContent.ContentPdfUrl or fileCount > 0 %}
        <aside class="files">
            <span class="files__title">{{ translations.FilesToDownload }}:</span>
            {% if formalContent.ContentPdfUrl %}
                        {% capture contentPdfHref -%}{% include 'partials/common/user-link.html', userLink: formalContent.ContentPdfUrl -%}{% endcapture -%}
                        <a aria-label="formalContent" href="{{ contentPdfHref }}" target="_blank" rel="noopener noreferrer">
                            <svg class="file-icon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#paperclip-{{settings.iconStyle}}"></use></svg>
                            {{ formalContent.Name }}
                        </a>
            {% endif -%}
            {% if fileCount > 0 %}
                {% for file in formalContent.Files %}
                        {% capture fileHref -%}{% include 'partials/common/user-link.html', userLink: file.Url -%}{% endcapture -%}
                        <a aria-label="file" href="{{ fileHref }}" target="_blank" rel="noopener noreferrer">
                            <svg class="file-icon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#paperclip-{{settings.iconStyle}}"></use></svg>
                            {{ file.Name }}
                        </a>
                {% endfor %}
            {% endif %}
        </aside>
    {% endif %}
</article>
`